import { useLocation } from 'react-router-dom';
import { allSuites } from '@suites/registry';
import { SuiteManifest } from '@suites/manifest';

/**
 * Returns the currently active SuiteManifest based on the router pathname.
 */
export function useActiveSuite(): SuiteManifest | undefined {
  const { pathname } = useLocation();

  return allSuites.find((suite) => {
    if (suite.basePath === '/') {
      return pathname === '/';
    }
    return pathname === suite.basePath || pathname.startsWith(`${suite.basePath}/`);
  });
}
